import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { Divider, Drawer } from '@material-ui/core';
import DashboardIcon from '@material-ui/icons/Dashboard';
import PeopleIcon from '@material-ui/icons/People';
import ShoppingBasketIcon from '@material-ui/icons/ShoppingBasket';
import TextFieldsIcon from '@material-ui/icons/TextFields';
import ImageIcon from '@material-ui/icons/Image';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import SettingsIcon from '@material-ui/icons/Settings';
import LockOpenIcon from '@material-ui/icons/LockOpen';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import ListIcon from '@material-ui/icons/List';
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn';
import LocalCafeIcon from '@material-ui/icons/LocalCafe';
import GroupIcon from '@material-ui/icons/Group';
import RestaurantIcon from '@material-ui/icons/Restaurant';
import MenuBookIcon from '@material-ui/icons/MenuBook';
import LocalAtmIcon from '@material-ui/icons/LocalAtm';
import FaceIcon from '@material-ui/icons/Face';

import { Profile, SidebarNav, UpgradePlan } from './components';

import { useSelector } from 'react-redux';
import { roleSelector } from '../../../../store/login';

const useStyles = makeStyles(theme => ({
  drawer: {
    width: 240,
    [theme.breakpoints.up('lg')]: {
      marginTop: 64,
      height: 'calc(100% - 64px)'
    }
  },
  root: {
    backgroundColor: theme.palette.white,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
    padding: theme.spacing(2)
  },
  divider: {
    margin: theme.spacing(2, 0)
  },
  nav: {
    marginBottom: theme.spacing(2)
  }
}));

const Sidebar = props => {
  const { open, variant, onClose, className, ...rest } = props;
  const userRole = useSelector(roleSelector);

  const classes = useStyles();

  const staffPages = [
    {
      title: 'Выдача обедов',
      href: '/checkin',
      icon: <AssignmentTurnedInIcon />
    }
  ];
  const adminPages = [
    {
      title: 'Новый билет',
      href: '/order/new',
      icon: <AddCircleIcon />
    },
    // {
    //   title: 'Dashboard',
    //   href: '/dashboard',
    //   icon: <DashboardIcon />
    // },
    {
      title: 'Список билетов',
      href: '/orders',
      icon: <ListIcon />
    },
    {
      title: 'Список блюд',
      href: '/dishes',
      icon: <RestaurantIcon />
    },
    {
      title: 'Меню на день',
      href: '/daily_menu',
      icon: <MenuBookIcon />
    },
    {
      title: 'Кредиторы',
      href: '/accounts',
      icon: <FaceIcon />
    },
    {
      title: 'Отчет по деньгам',
      href: '/money',
      icon: <MonetizationOnIcon />
    },
    {
      title: 'Сумма по деньгам',
      href: '/days_money',
      icon: <LocalAtmIcon />
    },
    {
      title: 'Отчет по обедам',
      href: '/meal',
      icon: <LocalCafeIcon />
    },

    {
      title: 'Выдача обедов',
      href: '/checkin',
      icon: <AssignmentTurnedInIcon />
    },

    {
      title: 'Учет еды для сотруднков',
      href: '/team',
      icon: <GroupIcon />
    }
  ];
  const mangerPages = [
    {
      title: 'Новый билет',
      href: '/order/new',
      icon: <AddCircleIcon />
    },

    {
      title: 'Список билетов',
      href: '/orders',
      icon: <ListIcon />
    },
    {
      title: 'Список блюд',
      href: '/dishes',
      icon: <RestaurantIcon />
    },
    {
      title: 'Меню на день',
      href: '/daily_menu',
      icon: <MenuBookIcon />
    },
    {
      title: 'Отчет по обедам',
      href: '/meal',
      icon: <LocalCafeIcon />
    }
  ];

  let pages = [];
  switch (userRole) {
    case 'admin':
      pages = adminPages;
      break;
    case 'manager':
      pages = mangerPages;
      break;
    case 'staff':
      pages = staffPages;
      break;
  }

  return (
    <Drawer
      anchor="left"
      classes={{ paper: classes.drawer }}
      onClose={onClose}
      open={open}
      variant={variant}>
      <div {...rest} className={clsx(classes.root, className)}>
        {/* <Profile /> */}
        <Divider className={classes.divider} />
        <SidebarNav className={classes.nav} pages={pages} onClose={onClose} />
        {/* <UpgradePlan /> */}
      </div>
    </Drawer>
  );
};

Sidebar.propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func,
  open: PropTypes.bool.isRequired,
  variant: PropTypes.string.isRequired
};

export default Sidebar;
